module.exports = __webpack_public_path__ + "img/art-6.1a1c7120.png";